export const lang_CN = {
  ProductIntroduction: '产品介绍',
  ProductDetail: "产品详情",
  CaseDetails: "案例详情",
  home: '首页',
  product: '产品中心',
  case: '案例中心',
  contact: '联系我们',
  home1: 'LED室内外高清LED大屏',
  home2: 'LED租赁全彩系列',
  home3: 'LED室内外全彩透明屏',
  home4: 'LED广告机',
  home5: 'LED异形屏',
  product1: '高清常规LED显示屏',
  product1_1: '精致画质，震撼视觉体验',
  prcducrt1_1_1: '高刷新、高灰度、高对比度以及出色的颜色处理能力',
  prcducrt1_1_2: '呈现流畅细腻的画面效果',
  prcducrt1_1_3: '拍照效果好',
  product1_2: '高效散热，大幅延长使用寿命',
  prcduct1_2_1: '采用铝材质箱体，传导散热快',
  prcduct1_2_2: '鳍形散热设计，增加表面积，对流散热快',
  prcduct1_2_3: '有效减缓内部元器件老化，大幅延长使用寿命',

  product1_3: '轻薄压铸箱，省安装空间，维护便捷',
  product1_3_1: '模组前维护，电源盒模块化维护，快速便捷',
  product1_3_2: '超薄箱体，贴墙安装，节省空间',

  product1_4: '支持直角拼接应用，带来更高商业价值',
  product1_4_1: '可依据建筑结构调整为直角拼接，带来震撼的90°转角视觉效果',
  product1_4_2: '完美匹配裸眼3D创意视效，赋能创意营销价值最大化',

  product1_1_1_1: '多元室内外广告显示场景皆可满足',
  product1_1_1_2: '会议室',
  product1_1_1_3: '服装店',
  product1_1_1_4: '商场',
  product1_1_1_5: '博物馆',
  product1_1_1_6: '教室',
  product1_1_1_7: '汽车店',
  //产品2
  product2: 'LED租赁全彩系列',

  product2_1: '方便快捷',
  product2_1_1: '轻薄设计，快速安装',
  product2_1_2: '上下搭配快速锁，可实现单人安装',
  product2_1_3: '把手包胶处理，防滑不咯手，方便安装',
  //
  product2_2: '平整度佳',
  product2_2_1: '箱体整体压铸成型，精度高，确保箱体的平整度',
  product2_2_2: '上下有定位柱，可以快速定位，以确保安装时平整度',
  //
  product2_3: '多种安装方式，形式灵活',
  product2_3_1: '支持吊装和堆装，帮助客户轻松应对各种搭建环境考验。',
  product2_3_2: '此外还提供日字架安装解决方案，帮助客户节省更多的人力物力成本。',
  //
  product2_4: '显示效果好',
  product2_4_1: '高刷显示：>3840Hz刷新率，观看更舒适，拍摄无扫描线',
  product2_4_2: '标配面罩，防眩光，提升一致性',
  //
  product2_1_1_1: '多元室内外广告显示场景皆可满足',
  product2_1_1_2: '户外商演',
  product2_1_1_3: '户外商演',
  product2_1_1_4: '演唱会',
  //
  product3_1: 'LED室内外全彩透明屏',
  product3_1_1: '轻 薄 通透 ',
  product3_1_2: 'P3.9的小间距，保证了透明显示时的清晰度，提升近距离观看体验',
  product3_1_3: '高亮的灯珠使屏幕播放内容即使在白天也炫彩通透。',

  product3_2_1: '模块化组装',
  product3_2_2: '采用模块化设计，快速拼屏，拼屏后整个大屏形成一整块屏体',

  product3_3_1: '快速安装维护',
  product3_3_2: '箱体内置螺纹铆钉',
  product3_3_3: '仅需几颗螺丝就可实现安装',
  product3_3_4: '通用且方便快速',
  //
  product3_1_1_1: '多元室内外广告显示场景皆可满足',
  product3_1_1_2: '商场',
  product3_1_1_3: '珠宝店',
  product3_1_1_4: '展厅',
  product3_1_1_5: '餐馆',
  product3_1_1_6: '商场',
  product3_1_1_7: '户外',
  //
  product4_1: '全息透明屏',
  product4_1_1: '透',
  product4_1_2: '采用无龙骨结构设计，实现全屏透明隐形效果，观看通透率可达90%以上。',
  product4_1_3: '完美适配建筑原有采光设计，打造通透自然的空间视觉体验。',

  product4_2_1: '空间悬浮影像',
  product4_2_2: '于透明玻璃屏上方呈现裸眼3D悬浮影像，为用户打造沉浸式立体观感体验。',

  product4_3_1: '可弯曲，可裁剪',
  product4_3_2: '不受尺寸形状限制，适应弧形结构',

  product4_4_1: '多样化安装方式',
  product4_4_2: '贴装',
  product4_4_3: '立式',
  product4_4_4: '吊装',

  product5_1: 'LED广告机',
  product5_1_1: '采用“地砖级GOB工艺’',
  product5_1_2: '表面防溅水,防刮花,放磕碰,防潮,稳定性更好',

  product5_2_1: '无需安装，通电即用',
  product5_2_2: '成品发货,无需专业技术安装调试,即插即用',

  product5_3_1: '支持多台无缝拼接',
  product5_3_2: '可单台使用,同时也支持多台无缝拼接成一个大屏,应用场景更加广泛',

  product5_4_1: '万向轮设计',
  product5_4_2: '支持手机一键上传内容,傻瓜式软件,小白都能轻松操作',

  product5_1_1_1: "应用场景案例展示",

  product6_1: '柔性LED晶膜屏',
  product6_1_1: '隐藏安装、凸显科技',
  product6_1_2: '轻、透、薄、柔的特性，应用于玻璃栈道自动门窗、室内隔断、商业橱窗、科技展厅!文旅、商业护栏、博物展馆等场景，科技感倍增',
  product6_2_1: '无需框架、即装即用',
  product6_2_2: '透明薄膜屏直接贴附玻璃表面，快速极简安装，节省大量框架、审批、安装及人工成本',
  product6_3_1: '户内安装、户外交流',
  product6_3_2: '避免户外安装标牌审查管控，可室内安装，实现户外商显',
  product6_4_1: '可剪裁为异型',
  product6_4_2: '光艺术秀场新宠，结合结构框架，白天隐形，夜晚凌空画面呈现，成吸晴焦点',
  product6_1_1_1: "应用场景案例展示",
  product6_1_1_2: "商场电梯",
  product6_1_1_3: "楼宇玻璃",
  product6_1_1_4: "室内玻璃",
  product6_1_1_5: "展厅",
  product6_1_1_6: "商场",
  product6_1_1_7: "门头招牌",

  product7_1: 'LED魔方屏',
  product7_1_1: '选用优质灯珠',
  product7_1_2: '打造超高动态对比度优质显示效果，使其画面黑白对比强烈、分明，保证画面的通透与亮度',
  product7_2_1: '专业拼接，美观大方',
  product7_3_1: '网红魔方屏，门店引流神器',
  product7_1_1_1: "应用场景案例展示",
  product7_1_1_2: "室内装饰",
  product7_1_1_3: "超市",
  product7_1_1_4: "门头招牌",
  product7_1_1_5: "门头招牌",
  product7_1_1_6: "室内装饰",
  product7_1_1_7: "室内装饰",

  product8_1: 'LED圆饼屏',
  product8_1_1: '圆形设计',
  product8_1_2: '独特薄框圆形设计，打破了传统矩形显示屏的局限，为信息呈现提供了更多的可能性，不仅美观大方，更能吸引人们注意力，提神品牌形象。',
  product8_2_1: '多彩高亮显示屏完美色彩还原',
  product8_2_2: '可支持定制任意分辨率，满足各种场景需求瞬间吸引远处顾客的目光',
  product8_3_1: '超长寿命升级LED新型灯珠',
  product8_3_2: '超长寿命，高稳定性色彩鲜艳，效果更逼真',
  product8_4_1: '手机 电脑 一键上传创意视频',
  Phone: "电话",
  Address: "地址",
  GetQuote: "获取报价",
  LeaveYourInfo: '请留下您的需求和联系方式，我们会尽快与您取得联系',
  SalesPhone: "营销手机",
  CustomerServicePhone: "客服手机",
  Email: "邮 箱",
  ReceptionPhone: "前台座机",
  Fax: "传 真",
  PostalCode: "邮 编",
  YourName: "您的名字",
  EnterYourName: "请输入您的名称",
  YourPhone: "您的手机",
  EnterYourPhone: "请输入您的手机",
  YourRequirements: "您的需求",
  EnterYourRequirements: "输入您的需求",
  Submit: "提交",
  MrLiu: "刘先生",
  MsFan: "樊小姐",
  ClassicCases: "经典案例",
  P186FiveUnitsParallel: "p1.86五台并联",
  P25Indoor: "p2.5室内",
  CakeShopCase: "蛋糕店案例",
  ClothingStoreCase: "服装店案例",
  DigitalSignageCase: "广告机案例",
  IndoorDigitalSignage2: "室内广告机 (2)",
  IndoorDigitalSignage3: "室内广告机 (3)",
  IndoorDigitalSignage: "室内广告机",

  TianjinStageRental: "天津舞台租赁",
  UKOutdoorProjectCase: "英国户外项目案例",
  NantongOutdoorRentalProject: "南通户外租赁项目",

  ShanghaiIndoorSmallPitch: "上海室内小间距",
  MeetingRoomIndoorProject: "会议室室内项目",
  MeetingRoomSmallPitch: "会议室小间距",
  MeetingRoomCase: "会议室案例",
  MeetingRoomProject: "会议室项目",
  HospitalMeetingRoomProject: "医院会议室项目",
  MuseumSmallPitchIndoorScreen: "博物馆小间距室内屏",
  ShoppingMallIndoorProject: "商场室内项目",
  ShoppingMallSmallPitch: "商场小间距",
  ShoppingMallOutdoorLargeScreen: "商场户外大屏",
  ShoppingMallClothingStore: "商场服装店",
  LEDCrystalFilmScreen: "LED晶膜屏",
  ConferenceDisplayMagicCubeScreen: "会议展示魔方屏",
  ClothingStoreLEDMagicCubeScreen: "服装店LED魔方屏",
  Supermarket: "超市",
  SupermarketIndoorLEDMagicCubeScreen: "超市室内LED魔方屏",
  RestaurantLEDMagicCubeScreen: "餐饮店LED魔方屏",
  MagicCubeOfficeDisplay: "魔方办公室摆台",
  RestaurantCase: "餐饮案例",
  DiningCase: "餐馆案例",
  CrystalFilmScreenCase: "晶膜屏案例",
  ShanghaiShoppingMallProject: "上海商场项目",
  ShanghaiTowerProject: "上海铁塔项目",
  ShanghaiMinhangProject: "上海闵行项目",
  BaodingMuseumProject: "保定博物馆项目",
  BeijingJewelryStoreProject: "北京珠宝店项目",
  ShoppingMallTransparentScreenCase: "商场透明屏案例",
  CommercialPerformanceProject: "商演项目",
  RoundTransparentScreenCase: "圆形透明屏案例",
  SubwayStationProject: "地铁站项目",
  NingboOutdoorProject: "宁波户外项目",
  ShenzhenHeadquarters: "深圳总部",
  DongguanIntelligentManufacturingBase: "东莞智能制造基地",
  PHONE111 :'18118700596',
  PHONE222 :'18739767975'
}
//  首页
// 产品中心
// 案例中心
// 联系我们